module.exports = __webpack_public_path__ + "static/plant-974f15821516c6a8824b9b5df68941de.png";